// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"cd589c2b","157":"a4d3afb1","632":"cd589c2b","804":"cd589c2b","936":"cd589c2b"}[chunkId] + ".chunk.css";
};